import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dah7gc3oh653ivfvnn80";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，新事件梳理会第一时间发给你。");
      return;
    }
    formData.delete("website_alt");

    setStatus("loading");
    setMessage("");

    const body = new URLSearchParams();
    formData.forEach((value, key) => body.append(key, String(value)));

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMessage =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMessage === "string" && serverMessage.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，新事件梳理会第一时间发给你。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMessage || "订阅失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络不太稳定，请稍后再试一次。");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      data-readdy-form
      id="gualine-newsletter-form"
      className="flex flex-col sm:flex-row gap-3"
    >
      <div className="gossip-field-shield" aria-hidden="true">
        <label htmlFor="newsletter-website-alt">网址备用</label>
        <input
          id="newsletter-website-alt"
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
      </div>

      <label className="sr-only" htmlFor="newsletter-email">
        常用邮箱
      </label>
      <input
        id="newsletter-email"
        type="email"
        name="email"
        required
        placeholder="填写常用邮箱，接收最新时间线"
        className="flex-1 rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
      />
      <button
        type="submit"
        disabled={status === "loading"}
        className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600 disabled:opacity-60 cursor-pointer"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-send-plane-line" />
        </span>
        {status === "loading" ? "提交中" : "订阅更新"}
      </button>

      {message && (
        <p
          className={`sm:order-last sm:w-full text-xs ${
            status === "error" ? "text-primary-700" : "text-secondary-700"
          }`}
          role="status"
        >
          {message}
        </p>
      )}
    </form>
  );
}